import { Component, OnInit } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { AuditTemplateService } from '../../services/audit-template.service';
import { AuditTemplateDetailsModel } from '../../models/audit-template-details.model';

@Component({
  selector: 'app-audit-template-modules',
  templateUrl: './audit-template-modules.component.html',
  styleUrls: ['./audit-template-modules.component.css']
})
export class AuditTemplateModulesComponent implements OnInit {
    headerTitle: IHeaderTitle;
    auditTemplateId: string;
    auditTemplateDetailsModel: AuditTemplateDetailsModel;
    isAddMode: boolean = false;

    constructor(
        private auditTemplateService: AuditTemplateService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.auditTemplateId = this.activatedRoute.snapshot.params['id'];
        this.load();
    }

    load(): void {
        this.auditTemplateService.get(this.auditTemplateId).subscribe(result => {
            this.auditTemplateDetailsModel = result;
            this.headerTitle = {
                title: result.description,
                breadcrumbs: [{ title: 'Audit Templates', url: ['/audit-template'] }]
            };
        });
    }

    toggleAddMode(): void {
        this.isAddMode = !this.isAddMode;
    }

    auditTemplateModuleAdded($event: string): void {
        this.load();
        this.isAddMode = false;

    }

}
